import {RequestHelper} from "@/helpers/index";
import {AFFILIATES} from '../factories';

export default {
  getHost () {
    let domainname = location.host

    domainname = domainname.replace('-submission', '')
    domainname = domainname.replace('-form', '')

    let host = domainname.split('.')[0]

		const aid = RequestHelper.getQueryVariable('aid');
		const aidIndex = RequestHelper.getQueryVariable('aid_index');

		if (aid) {
			const hosts:any = [];
			Object.keys(AFFILIATES).forEach(function(key:string) {
				const affiliates:any = AFFILIATES;
				if(affiliates[key].affiliateUserId === Number(aid)) {
					hosts.push(key);
				}
			});

			if(hosts.length > 0) {
				host = aidIndex ? hosts[aidIndex] : hosts[0];
			}
		}

		if (host)
			host = host.toLowerCase();

    return host
  }
}
